/**
 * @module バリデーションユーティリティ
 */
import CONSTANTS from '../constants';

/**
 * ASCII文字(制御文字除く)、JIS X 0208に含まれる文字のみからなる文字列かどうかチェック
 * @param {string} str チェックする文字列
 * @returns {boolean} チェック結果
 */
export function checkASCIIAndJISX0208(str) {
  for (const char of str) {
    if (!((char >= ' ' && char <= '~') || CONSTANTS.JIS.JIS_X_0208.includes(char))) {
      return false;
    }
  }
  return true;
}

/**
 * メールアドレス形式のバリデーションチェック
 * @param {string} str チェックする文字列
 * @returns {boolean} チェック結果
 */
export function checkMailAddressFormat(str) {
  return (
    /^[a-zA-Z0-9 !#$%&'*+-./=?^_`{|}~]*@{1}[a-zA-Z0-9 !#$%&'*+-./=?^_`{|}~]{1,}\.[a-zA-Z0-9 !#$%&'*+-./=?^_`{|}~]*[a-zA-Z0-9]{1,}$/.test(
      str
    ) && (str.match(/@/g) || []).length === 1
  );
}
